
import { Component, OnInit, ChangeDetectionStrategy, output } from '@angular/core';
import { TranslateModule,  } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'no-client-trial',
  templateUrl: './no-client-trial.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonModule,
    TranslateModule
]
})
export class NoClientTrialComponent {
  readonly onAction = output<{ action: string }>();
  
  constructor() { }

  addTrail(){
    this.onAction.emit({action:"CreateClientTrial"});
  }

}
